if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
        this.initDesktopSliderButtons();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        if (!this.mql.matches) {
          this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
            element.classList.remove('is-active');
          });

          activeMedia?.classList?.add('is-active');
        }

        if (prepend) {
          activeMedia.parentElement.firstChild !== activeMedia && activeMedia.parentElement.prepend(activeMedia);

          if (this.elements.thumbnails) {
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            activeThumbnail.parentElement.firstChild !== activeThumbnail && activeThumbnail.parentElement.prepend(activeThumbnail);
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
        activeMedia.parentElement.scrollTo({
          left: activeMedia.offsetLeft,
          behavior: 'smooth',
        });
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        const slider = this.elements.thumbnails.slider;
        const thumbRect = thumbnail.getBoundingClientRect();
        const sliderRect = slider.getBoundingClientRect();
        const isVisibleInSlider =
          thumbRect.top >= sliderRect.top - 1 &&
          thumbRect.left >= sliderRect.left - 1 &&
          thumbRect.bottom <= sliderRect.bottom + 1 &&
          thumbRect.right <= sliderRect.right + 1;
        if (isVisibleInSlider) return;

        let scrollTop = slider.scrollTop;
        let scrollLeft = slider.scrollLeft;
        if (thumbRect.top < sliderRect.top) {
          scrollTop = slider.scrollTop + thumbRect.top - sliderRect.top - 8;
        } else if (thumbRect.bottom > sliderRect.bottom) {
          scrollTop = slider.scrollTop + thumbRect.bottom - sliderRect.bottom + 8;
        }
        if (thumbRect.left < sliderRect.left) {
          scrollLeft = slider.scrollLeft + thumbRect.left - sliderRect.left - 8;
        } else if (thumbRect.right > sliderRect.right) {
          scrollLeft = slider.scrollLeft + thumbRect.right - sliderRect.right + 8;
        }
        slider.scrollTo({ left: scrollLeft, top: scrollTop, behavior: 'smooth' });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }

      initDesktopSliderButtons() {
        const prevButton = this.querySelector('.slider-button--prev');
        const nextButton = this.querySelector('.slider-button--next');

        if (!prevButton || !nextButton) return;

        prevButton.addEventListener('click', () => {
          const container = this.elements.viewer.querySelector('.product__media-list');
          container.scrollBy({
            left: -container.offsetWidth,
            behavior: 'smooth',
          });
        });

        nextButton.addEventListener('click', () => {
          const container = this.elements.viewer.querySelector('.product__media-list');
          container.scrollBy({
            left: container.offsetWidth,
            behavior: 'smooth',
          });
        });
      }
    }
  );
}
